import { Pipe, PipeTransform } from '@angular/core';
import { FinancialItem } from '@macs-frontend/features/company-management/financial/reducers/financial-items';
import { ActionsList } from '@macs-frontend/features/company-management/manage/containers/supplier-details/supplier-details.component';
import { ExpenseStatuses } from '@macs-frontend/features/company-management/manage/models/expense';
import { RatesheetValueTypes } from '@macs-frontend/features/company-management/ratesheet/enums/ratesheet-value-types.enum';
import { RatesheetStatuses } from '../enums/ratesheet-statuses';
import { SupplierStatuses } from '../enums/supplier-statuses';
import { BillingMethodsEnum } from '../enums/team-task-billing-methods.enum';
import { BudgetTypes } from '../enums/team-task-budgets.enum';
import { MaterialGroupTypes } from '../models/action-team';
import { ClientStatuses } from '../models/client';
import { CompanyStatuses } from '../models/company.model';
import { ContactStatuses } from '../models/contact';
import { InvoiceItemGroup } from '../models/invoice-item-group.model';
import { ProjectStatuses } from '../models/project';
import { SPOStatuses } from '../models/spo';
import { TaskStatuses } from '../models/task.model';
import { UserStatuses } from '../models/user.model';
import { ContractTemplateStatuses } from '@macs-frontend/features/shared/models/contract-template';
import { ActionStatus } from '@macs-gql';

/**
 * @deprecated this pipe was only temporary solution for enable "strict" option in typescript,
 *              it should be deleted where possible.
 */
@Pipe({ name: 'to', pure: true })
export class ToPipe implements PipeTransform {
  transform<T extends keyof ToValues>(
    value: ToValues[T]['from'],
    _type: T,
  ): ToValues[T]['to'] {
    return value as ToValues[T]['to'];
  }
}

type scalar = number | string | undefined | null | boolean;

export interface ToValues {
  'number[]': {
    from: scalar[];
    to: number[];
  };
  'string[]': {
    from: scalar[];
    to: string[];
  };
  number: {
    from: scalar;
    to: number;
  };
  string: {
    from: scalar;
    to: string;
  };
  ActionStatus: {
    from: string;
    to: ActionStatus;
  };
  InvoiceItemGroup: {
    from: FinancialItem;
    to: InvoiceItemGroup;
  };
  HTMLInputElement: {
    from: EventTarget;
    to: HTMLInputElement;
  };
  SPOStatuses: {
    from: string;
    to: SPOStatuses;
  };
  BudgetTypes: {
    from: string;
    to: BudgetTypes;
  };
  MaterialGroupTypes: {
    from: string;
    to: MaterialGroupTypes;
  };
  ProjectStatuses: {
    from: string;
    to: ProjectStatuses;
  };
  ContactStatuses: {
    from: string;
    to: ContactStatuses;
  };
  ContractTemplateStatuses: {
    from: string;
    to: ContractTemplateStatuses;
  };
  RatesheetValueTypes: {
    from: string;
    to: RatesheetValueTypes;
  };
  RatesheetStatuses: {
    from: string;
    to: RatesheetStatuses;
  };
  ActionsList: {
    from: string;
    to: ActionsList;
  };
  SupplierStatuses: {
    from: string;
    to: SupplierStatuses;
  };
  TaskStatuses: {
    from: string;
    to: TaskStatuses;
  };
  UserStatuses: {
    from: string;
    to: UserStatuses;
  };
  ExpenseStatuses: {
    from: string;
    to: ExpenseStatuses;
  };
  ClientStatuses: {
    from: string;
    to: ClientStatuses;
  };
  CompanyStatuses: {
    from: string;
    to: CompanyStatuses;
  };
  BillingMethodsEnum: {
    from: string;
    to: BillingMethodsEnum;
  };
}
